import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteWorkflowAssignmentArguments {
  params: OpalApiRequestParams<'DeleteWorkflowAssignmentV3'>
}

export async function deleteWorkflowAssignment({
  params,
}: DeleteWorkflowAssignmentArguments): Promise<null> {
  const url = new URL(
    `/v3/workflow_assignments/${params.path.workflow_assignment_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
